<template>
    <div class="benefits">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="benefits__header">
                        <p class="benefits__title benefits__text">Benefits of using CrossProm</p>
                        <p class="benefits__description benefits__text">There are tons of things to do during your campaign. Automation of these processes will help reduce the time you spend sevenfold.</p>
                    </div>
                    <div class="benefits__body d-flex flex-lg-row flex-column justify-content-center align-items-center">
                        <div class="benefits__column benefits__without-cp">
                            <div class="benefits__column__header d-flex align-items-center">
                                <p class="benefits__text benefits__column__title">When you do CPs manually</p>
                            </div>
                            <ul class="benefits__list">
                                <li class="benefits__list__without-cp">
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">Multiple channels messaging over possible cross-promotion</p>
                                    </div>
                                </li>
                                <li class="benefits__list__without-cp">
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">Manual CrossProm info sharing</p>
                                    </div>
                                </li>
                                <li class="benefits__list__without-cp">
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">Manual custom link creation for every cross-promotion agreement</p>
                                    </div>
                                </li>
                                <li class="benefits__list__without-cp">
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">Manual checking and follow up for your campaign posting</p>
                                    </div>
                                </li>
                                <li class="benefits__list__without-cp">
                                    <div class="benefits__list__item-container last">
                                        <p class="benefits__text benefits__list__text">Manual copy and paste of cross-promotion info of your partners into your Kickstarter update</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="benefits__column benefits__with-cp">
                            <div class="benefits__column__header d-flex align-items-center">
                                <p class="benefits__text benefits__column__title">With</p>
                                <Icon icon="logo-lg"/>
                            </div>
                            <ul class="benefits__list">
                                <li class="benefits__list__with-cp">
                                    <div class="benefits__list__image-container">
                                        <Icon icon="benefit-manage"/>
                                    </div>
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">One dashboard to manage all cross-promotion requests</p>   
                                    </div>
                                </li>
                                <li class="benefits__list__with-cp">
                                    <div class="benefits__list__image-container">
                                        <Icon icon="benefit-info"/>
                                    </div>
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">CrossProm info template shared with your partners automatically </p>   
                                    </div>
                                </li>
                                <li class="benefits__list__with-cp">
                                    <div class="benefits__list__image-container">
                                        <Icon icon="benefit-customlink"/>
                                    </div>
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">Automatic custom links creation for every cross-promotion agreement</p>   
                                    </div>
                                </li>
                                <li class="benefits__list__with-cp">
                                    <div class="benefits__list__image-container">
                                        <Icon icon="benefit-auto-nots"/>
                                    </div>
                                    <div class="benefits__list__item-container">
                                        <p class="benefits__text benefits__list__text">Automatic notifications when your campaign is posted in updates</p>   
                                    </div>
                                </li>
                                <li class="benefits__list__with-cp">
                                    <div class="benefits__list__image-container">
                                        <Icon icon="benefit-autocreat"/>
                                    </div>
                                    <div class="benefits__list__item-container last">
                                        <p class="benefits__text benefits__list__text">Automatic creation of cross-promotions in the Kickstarter update draft with a single click </p>   
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'Benefits',
    components: {
        Icon
    }
}
</script>

<style lang="scss" scoped>
$text_color: #333333;
$fontsize_lg: 32px;
$fontsize_md: 24px;
$fontsize_sm: 18px;
$lineheight_sm: 28px;
$lineheight_lg: 39px;
$radius: 16px;
$grey: #f9f9f9;
$grey2: #f4f4f4;
$white: #ffffff;
$primary_color: #727CF5;
$padding: 40px;
$font: 'EinaBold';
.benefits {
    margin-top: 0;
    padding-top: 120px;
    padding-bottom: 88px;
    background: $white;
    @media (max-width: 992px){
        margin-top: 80px;
    }
    &__text {
        color: $text_color;
        margin-bottom: 0;
    }
    &__header {
        max-width: 670px;
        margin: 0 auto;
        padding-bottom: 48px;
    }
    &__title {
        font-size: $fontsize_lg;
        line-height: $lineheight_lg;
        font-family: $font;
        text-align: center;
        font-weight: bold;
    }
    &__description {
        font-size: $fontsize_sm;
        line-height: $lineheight_sm;
        text-align: center;
        margin-top: 12px;
    }
    &__column {
        width: 100%;
        min-height: 665px;
        border-radius: $radius;
        border-width: 4px;
        border-style: solid;
        padding-top: 40px;
        padding-left: 36px;
        @media (max-width: 505px){
            padding-left: 10px;
        }
        &__header {
            margin-bottom: 42px;
            img {
                margin-left: 8px;
            }
        }
        &__title {
            font-size: 24px;
            font-family: $font;
            position: relative;
            @media (max-width: 400px){
                font-size: 18px;
            }
            &::before {
                content: '';
                position: absolute;
                top: 100%;
                left: 0;
                width: 30px;
                height: 3px;
                background: $primary_color;
                transform: translateY(16px);
            }
        }
    }
    &__without-cp {
        background: $grey;
        border-color: transparent;
        max-width: 440px;
        min-width: 327px;
        margin-right: 40px;
        @media (max-width: 991px){
            margin-right: 0;
            margin-bottom: 32px;
        }
        @media (max-width: 505px){
            min-width: 100%;
        }
    }
    &__with-cp {
        border-color: $primary_color;
        max-width: 480px;
        min-width: 400px;
        @media (max-width: 505px){
            min-width: 100%;
        }
    }
    &__list {
        padding: 0;
        margin: 0;
        li {
            padding-right: 36px;
            position: relative;
            &:not(:first-child)  {
                height: 100px;
                padding-top: 24px;
                @media (max-width: 505px){
                    height: auto;
                }
            }
            @media (max-width: 505px){
                padding-right: 24px;
            }
        }
        &__without-cp {
            &::after {
                content: url(/icons/right-arrow-gradient.svg);
                position: absolute;
                top: 50%;
                left: 100%; 
                transform: translate(0, -50%);
                @media (max-width: 991px){
                    display: none
                }
            }
        }
        &__with-cp {
            display: flex;
            align-items: flex-start;
        }
        &__image-container {
            min-width: 48px;
            margin-right: 24px;
            margin-top: 8px;
        }
        &__text {
            font-size: $fontsize_sm;
            line-height: $lineheight_sm;
        }
        &__item-container {
            border-bottom: 1px solid $grey2;
            padding-bottom: 24px;
            height: 100%;
            &.last {
                border: none;
                padding-bottom: 24px;
            }
        }
    }
}
</style>